import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

export interface BreadcrumbItem {
  label: string;
  route?: string;
  icon?: string;
}

@Component({
  selector: 'app-breadcrumb',
  imports: [CommonModule, RouterModule],
  template: `
    <nav [attr.aria-label]="'Breadcrumb'" class="flex">
      <ol class="flex items-center space-x-2">
        @for (item of items(); track $index; let isLast = $last) {
          <li class="flex items-center">
            @if (isLast) {
              <span [class]="currentItemClasses">
                @if (item.icon) {
                  <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="item.icon" />
                  </svg>
                }
                {{ item.label }}
              </span>
            } @else {
              @if (item.route) {
                <a [routerLink]="item.route" [class]="linkClasses">
                  @if (item.icon) {
                    <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="item.icon" />
                    </svg>
                  }
                  {{ item.label }}
                </a>
              } @else {
                <span [class]="linkClasses">
                  @if (item.icon) {
                    <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="item.icon" />
                    </svg>
                  }
                  {{ item.label }}
                </span>
              }
            }
            @if (!isLast) {
              <svg class="w-4 h-4 mx-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
              </svg>
            }
          </li>
        }
      </ol>
    </nav>
  `,
  styles: []
})
export class BreadcrumbComponent {
  items = input<BreadcrumbItem[]>([]);

  get linkClasses(): string {
    return 'flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors';
  }

  get currentItemClasses(): string {
    return 'flex items-center text-sm font-semibold text-gray-900 dark:text-gray-100';
  }
}

